// frontend/src/hooks/useWarehouses.ts — the depots as a picker's small list
// (ADR-080 §3): the project's attached depots the viewer may see, asked whole
// when a picker opens (or for the names of a depot already chosen), a minute
// fresh. A disabled depot is an inactive row — a filter offers it once typed
// (ADR-080 §5). The depot pages (future work) grow this file.

import type { DepotsResponse } from '@ems-app/schemas/warehouses/depots';
import { apiClient } from '../lib/apiClient.js';
import type { SmallSource } from './useOptions.js';

export const depotsKeys = {
  /** The depots one may see — the picker's whole read. */
  all: (projectId: string) => ['depots', projectId] as const,
};

async function fetchDepots(projectId: string, signal?: AbortSignal): Promise<DepotsResponse> {
  const r = await apiClient.get<DepotsResponse>(`/projects/${projectId}/depots`, { signal });
  return r.data;
}

/** The depots as a picker's source (the small kind): the name, the code on the second line. */
export function depotsSource(projectId: string): SmallSource<DepotsResponse> {
  return {
    kind: 'small',
    queryKey: depotsKeys.all(projectId),
    fetch: (signal) => fetchDepots(projectId, signal),
    rows: (r) => r.items.map((d) => ({ id: d.id, label: d.name, description: d.reference, pickable: true, inactive: d.is_disabled, group: null })),
  };
}
